import { Record, List } from 'immutable'

export default Record(
  {
    id: null,
    createdAt: null,
    archivedAt: null,
    updatedAt: null,
    createdBy: null,
    threadId: null,
    content: '',
    entities: List(),
  },
  'comment'
)
